const PROTOCOL         = "http://"
// const DOMAIN           = "10.0.0.173:8080"
// const DOMAIN           = "localhost:8080"
const DOMAIN           = "10.0.0.239:8080"

// const DOMAIN = "shk-uat.cstl.com.hk/portal/api"
// const DOMAIN = "shk-ev.cstl.com.hk/portal/api"

const POSTFIX          = "api";
const VERSION          = "v1";
const NAMESPACE        = "";


const BASE_URL = `${PROTOCOL}/${DOMAIN}/${POSTFIX}`;
// const BASE_URL = 'https://ust-ev-uat.cstl.com.hk/portal/api/api';
const BASE_WS_URL = `ws://${DOMAIN}`;

const CURRENT_PROFILE = window.gconf.profile;

// const BASE_URL = `${PROTOCOL}/${DOMAIN}/${POSTFIX}/${VERSION}`;
export default {
  NAMESPACE,
  CURRENT_PROFILE,
  api: {
    DOMAIN,
    BASE_URL,
    BASE_WS_URL
  },
}
